import React, { useEffect } from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

import {
  PaginateProductTypeState,
} from "store/ducks/settings/product-type";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridProductTypes, FilterProductTypes } from "components/settings";
import { useFilters } from 'hooks/useFilters';

export const ListProductTypes: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('productTypes');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateProductType
  ) as PaginateProductTypeState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}
          <MenuSelector page="product-types" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertProductType") && (
            <S.ButtonMini
              onClick={() => history.push("/settings/product-types/new")}
            >
              {getTranslation("novoTipo")}
            </S.ButtonMini>
          )}
          <FilterProductTypes />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridProductTypes productTypes={data} />
        <Paginator
          pagination={pagination}
          settingsPage='productTypes'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
